import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CapabilityTo} from './capability-to';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CapabilityService {

  baseUrl = `${environment.baseUrl}/capabilities`;

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  getCapabilities(): Observable<CapabilityTo> {
    return this.httpClient.get<CapabilityTo>(`${this.baseUrl}`, {headers: this.authService.getHeaders()});
  }
}
